import { UserInfoUserType } from "@/lib/api/interfaces/user-profile.interface";
import React, { useContext } from "react";
import { Context } from "./context";
import { UnauthorizedAccess } from "./protected-route";
import { SuspenseWrapper } from "@/ui-components/ui/suspense-wrapper";

const InternalCustomerWrapper = ({
  internalComponent,
  customerComponent,
}: {
  internalComponent?: React.ReactNode;
  customerComponent?: React.ReactNode;
}) => {
  const { user } = useContext(Context);

  if (!user) {
    return null;
  }

  const isInternal = user.userType === UserInfoUserType.INTERNAL_USER;

  const internal = internalComponent || <UnauthorizedAccess />;
  const customer = customerComponent || <UnauthorizedAccess />;

  return (
    <SuspenseWrapper>
      {isInternal ? internal : customer}
    </SuspenseWrapper>
  );
};

export default InternalCustomerWrapper;
